import {CasinoLobbyArenaModel} from "../casino-lobby/casino-lobby-arena.model";
import {Check} from "@sparkware/app-utils";

export class NewLiveCasinoArenaAbModel extends CasinoLobbyArenaModel {
    get sortingGametypesMapOverride(): Record<number, number> | null {
        return Check.isEmpty(this.services.liveTableFeeds.aiSortingGamesMap) ? null : this.services.liveTableFeeds.aiSortingGamesMap;
    }
}